/* Built In Imports */
import dynamic from 'next/dynamic';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import AccordionFaq from '@components/Accordions/AccordionFaq';
import Faq from '@components/Accordions/Faq';
import FaqLinkedContent from '@components/Accordions/FaqLinkedContent';
import SimpleButton from '@components/Buttons/SimpleButton';
import BenefitsGroup from '@components/Card/BenefitsGroup';
import TwoColumn from '@components/Card/TwoColumn';
import Benefits from '@components/HNI/Sections/Benefits';
import Highlights from '@components/HNI/Sections/Highlights';
import Impact from '@components/HNI/Sections/Impact';
import Significance from '@components/HNI/Sections/Significance';
import Support from '@components/HNI/Sections/Support';
import Testimonial from '@components/HNI/Sections/Testimonial';
import TestimonialMaha from '@components/MahaAnnadanam/TestimonialMaha';
import TopBannerYs from '@components/HeaderBanner/TopBannerYs';
import ContentArea from '@components/Layout/ContentArea';
import Testimonials3Card from '@components/Sliders/Testimonials3Card';
import CommunityDeclaration from '@components/UI/Center/CommunityDeclaration';
import GlobalCenter from '@components/UI/Center/GlobalCenter';
import SectionUI from '@components/UI/Common/SectionUI';
import StyleConfig from '@components/UI/Common/StyleConfig';
import LargeBrownBullets from '@components/UI/Health/LargeBrownBullets';
import SPAlumni from '@landing_pages/Sadhanapada/SPAlumni';
import SPApply from '@landing_pages/Sadhanapada/SPApply';
import SPFaq from '@landing_pages/Sadhanapada/SPFaq';
import SPPath from '@landing_pages/Sadhanapada/SPPath';
import SPProgramDetails from '@landing_pages/Sadhanapada/SPProgramDetails';
import SPTakeBreak from '@landing_pages/Sadhanapada/SPTakeBreak';
import SPWebinar from '@landing_pages/Sadhanapada/SPWebinar';
import WhySP from '@landing_pages/Sadhanapada/WhySP';
import ChallengeForm from '@landing_pages/idy/ChallengeForm';
import FaqContents from '@landing_pages/idy/FaqContents';
import IdyBenefits from '@landing_pages/idy/IdyBenefits';
import IdyImportantMessage from '@landing_pages/idy/IdyImportantMessage';
import IdyInPerson from '@landing_pages/idy/IdyInPerson';
import IdyRegisterStickyButton from '@landing_pages/idy/IdyRegisterStickyButton';
import IdyTestimonial from '@landing_pages/idy/IdyTestimonial';
import InviteFriends from '@landing_pages/idy/InviteFriends';
import TamilResearch from '@landing_pages/inner-engineering-online/TamilResearch';
import ThreeColumnGroup from '@landing_pages/inner-engineering-online/ThreeColumnGroup';
import WideSadhguruBox from '@landing_pages/ishanga7/WideSadhguruBox';
import MiracleTopBanner from '@landing_pages/miracle-of-mind/Components/Banner/MiracleTopBanner';
import MomStickyButton from '@landing_pages/miracle-of-mind/Components/Button/MomStickyButton';
import MomFooter from '@landing_pages/miracle-of-mind/Components/Footer/MomFooter';
import MomForm from '@landing_pages/miracle-of-mind/Components/Form/MomForm';
import MomQuote from '@landing_pages/miracle-of-mind/Components/Quote/MomQuote';
import MeditationSlider from '@landing_pages/miracle-of-mind/Components/Sliders/MeditationSlider';
import WhatisMom from '@landing_pages/miracle-of-mind/Sections/WhatisMom';
import OnlineSatsangBanner from '@landing_pages/online-satsang/OnlineSatsangBanner';
import AboutSadhguru from '@sections/AboutSadhguru';
import ArtworkText3GroupColumn from '@sections/ArtworkText3GroupColumn';
import SeatingRegSection from '@sections/SeatingRegSection';
import SocialMediaIconsLatest from '@sections/SocialMediaIconsLatest';
import AllCenters from '@sections/centers/AllCenters';
import MainCentersDefaultImage from '@sections/centers/MainCentersDefaultImage';
import ProcessesAndOfferings from '@sections/centers/ProcessesAndOfferings';
import DonationPageOfflineDonationUi from '@sections/donation/DonationPageOfflineDonationUi';
import DonationPageTopBanner from '@sections/donation/DonationPageTopBanner';
import EducationalInitiatives from '@sections/educational-initiatives/EducationalInitiatives';
import ExploringSpiritualAmericaPoem from '@sections/events/ExploringSpiritualAmericaPoem';
import LeftZigzag from '@sections/events/LeftZigzag';
import RightZigzag from '@sections/events/RightZigzag';
import IshaOutreach from '@sections/isha-outreach/IshaOutreach';
import AppButton from '@sections/others/AppButton';
import BuyNow from '@sections/others/BuyNow';
import MobileApp from '@sections/others/MobileApp';
import FeaturesPBK from '@sections/pbkonline/FeaturesPBK';
import HighlightsPBK from '@sections/pbkonline/HighlightsPBK';
import ProgDetailPBK from '@sections/pbkonline/ProgDetailsPBK';
import SupportEmail from '@sections/pbkonline/SupportEmail';
import SocialSection from '@sections/project-samskriti/SocialSection';
import QuoteSection from '@sections/volunteer/QuoteSection';
import VariousVolunteerSection from '@sections/volunteer/VariousVolunteerSection';
import FindTeacher from '@sections/yoga-meditation/FindTeacher';
import TwoColumnHathaTeachersBlock from '@sections/yoga-meditation/TwoColumnHathaTeachersBlock';
import ProgDetailYs from '@sections/yoga-sandhya/ProgDetailYs';
import { IsoApiConstants } from '../../../constants';
import Quotehni from '../../HNI/Sections/Quotehni';
import Texthni from '../../HNI/Sections/Texthni';
import TopBanner from '../../HNI/Sections/TopBanner';
import EoeStyleConfig from '@landing_pages/eoe/Common/StyleConfig';
import EOEBenefitsGroup from '@landing_pages/eoe/sections/BenefitsGroup';
import Benefits3GroupColumn from '../../../sections/Benefits3ColumnGroup';
import OTPQuoteSection from '../../../sections/volunteer/OTPQuoteSection';
import OurTeamBanner from '../../../sections/OurTeamBanner';
import OtpTestimonials from '../../../sections/OtpTestimonials';
import JourneyAdBanner from '../../../sections/JourneyAdBanner';
import OtpJourneyOverview from '../../../sections/OtpJourneyOverview';
import TopBannerSM from '../../HeaderBanner/TopBannerSM';
import OfficialDigitalHandles from '../OfficialDigitalHandles';

/**
 * Renders Render Simple Button Component
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Simple Button Component
 */

const RenderSimpleButton = ({
  sectionContent,
  section,
  region,
  lang,
  pageConfig,
}) => {
  // const SimpleButton = dynamic(() => import('@components/Buttons/SimpleButton'));
  if (
    section.sectionId &&
    section.sectionId === IsoApiConstants.sectionId.healthButtonLoginPopup
  ) {
    return (
      <SimpleButton
        style={sectionContent}
        bType={section.sectionId}
        region={region}
        lang={lang}
        pageName={pageConfig?.pageName}
      />
    );
  } else {
    return (
      <SimpleButton
        style={sectionContent}
        region={region}
        lang={lang}
        pageConfig={pageConfig}
      />
    );
  }
};

const RenderStructuredText = ({ sectionContent, region, lang }) => {
  if (
    sectionContent.fieldId &&
    sectionContent.fieldId === IsoApiConstants.fieldId.largeBrownBulletsHealth
  ) {
    // const LargeBrownBullets = dynamic(() => import('@components/UI/Health/LargeBrownBullets'));
    return <LargeBrownBullets data={sectionContent.body} />;
  } else {
    return (
      <MidContainer>
        <Box id={sectionContent?.sectionId} className="event-text">
          <ContentArea
            mainContent={sectionContent.body}
            tAlign={sectionContent.style}
            region={region}
            lang={lang}
          />
        </Box>
      </MidContainer>
    );
  }
};

const RenderFAQs = ({ pageConfig, section, region, lang, pageName }) => {
  if (
    section.sectionContent &&
    section.sectionContent.length > 0 &&
    section.sectionContent[1]?._modelApiKey ===
      IsoApiConstants.sectionId.faqSectionLinkedContent
  ) {
    // const FaqLinkedContent = dynamic(() => import('@components/Accordions/FaqLinkedContent'));
    return (
      <MidContainer>
        <Box display="flex">
          <FaqLinkedContent
            mainSection={section}
            faqSection={section.sectionContent[1]?.faqs[0].faqs}
            region={region}
            lang={lang}
          />
        </Box>
      </MidContainer>
    );
  } else if (
    section.sectionId === IsoApiConstants.sectionId.frequentlyAskedQuestions ||
    section.sectionId === 'faq'
  ) {
    const SectionContent = section.sectionContent;
    return (
      <MidContainer w={'768'}>
        {SectionContent.map((section, idx) => {
          section._modelApiKey = section._modelApiKey
            ? section._modelApiKey
            : 'faq_section_v2';
          return <SectionUI sectionContent={section} pageConfig={pageConfig} />;
        })}
      </MidContainer>
    );
  } else if (section.sectionId === 'sadhguru-two-column') {
    // const TwoColumn = dynamic(() => import('@components/Card/TwoColumn'));
    return <TwoColumn section={section} />;
  } else {
    // const Faq = dynamic(() => import('@components/Accordions/Faq'));
    return (
      <MidContainer>
        <Box display="flex" width="full">
          <Faq
            pageConfig={pageConfig}
            faqSection={section}
            region={region}
            lang={lang}
            pageName={pageName}
          />
        </Box>
      </MidContainer>
    );
  }
};

const RenderSections = ({
  section,
  sectionContent,
  region,
  lang,
  pType,
  isLeftMenu,
  pageName,
  csrData,
  pageBody,
  pageConfig,
  disableButton,
  FYDdate,
  currentRegion,
}) => {
  // console.log("Sec is", section)
  if (
    section.sectionId === IsoApiConstants.sectionId.faqSectionStd ||
    section.sectionId?.toLocaleLowerCase() ===
      IsoApiConstants.sectionId?.faq.toLocaleLowerCase() ||
    section.sectionId === IsoApiConstants.sectionId.frequentlyAskedQuestions ||
    section.sectionId === IsoApiConstants.sectionId.faqSection ||
    section.sectionId === 'faq'
  ) {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <RenderFAQs section={section} region={region} lang={lang} pageName={pageName} pageConfig={pageConfig}  />
      </StyleConfig>
    );
  } else if (
    section.sectionId === IsoApiConstants.sectionId.processesAndOfferings ||
    section.sectionId === IsoApiConstants.sectionId.ritualsAndOfferings
  ) {
    // const ProcessesAndOfferings = dynamic(() => import('@sections/centers/ProcessesAndOfferings'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <ProcessesAndOfferings section={section} region={region} lang={lang} />
      </StyleConfig>
    );
  }
  //  else if (section.sectionId === 'banner') {
  //   // const AboutSadhguru = dynamic(() => import('@sections/AboutSadhguru'));
  //   return (
  //     <StyleConfig
  //       id={section?.sectionId}
  //       key={section.sectionId}
  //       style={section?.styleConfig}
  //     >
  //       <TopBanner
  //         section={section}
  //         region={region}
  //         language={lang}
  //         isLeftMenu={isLeftMenu}
  //         pType={pType}
  //         pageName={pageName}
  //         csrData={csrData}
  //         pageBody={pageBody}
  //       />
  //     </StyleConfig>
  //   );
  // }
  else if (section.sectionId === 'testimonial-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Testimonial
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  }  else if (section.sectionId === 'testimonial-maha') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <TestimonialMaha
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'significance-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Significance
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
          pageBody={pageBody}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'impact-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Impact
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'support-spiritual-seekers') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={{ bgColour: { hex: '#FFEBC7' } }}
        background="#FFEBC7"
      >
        <Support
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'highlights-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        backgroundPosition={{ base: 'top center', md: 'top' }}
        backgroundSize={{ base: 'cover', md: 'auto' }}
        backgroundRepeat="no-repeat"
      >
        <Highlights
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'benefits-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Benefits
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'top-banner-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        zIndex="0"
      >
        <TopBanner
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'quote-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        zIndex="1"
      >
        <Quotehni
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
          bg={section.styleConfig.bgColour.hex}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'text-hni') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Texthni
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'kshetra-program-details') {
    return <ProgramDetails sectionData={section.sectionContent} />;
  } else if (section.sectionId === 'glimpses-of-sadhguru-sannidhi') {
    return (
      <Box py={{ base: '25px', md: '40px' }}>
        <StyleConfig
          id={section?.sectionId}
          key={section.sectionId}
          style={section?.styleConfig}
        >
          {section?.sectionContent?.map((content, index) => {
            if (content._modelApiKey === 'section_title') {
              return <KsSectionTitle sectionContent={content} />;
            } else if (content._modelApiKey === 'gallery') {
              return <Gallery key={content.id} sectionContent={content} />;
            } else {
              return null;
            }
          })}
        </StyleConfig>
      </Box>
    );
  } else if (section.sectionId === 'kshetra-faq') {
    return (
      <StyleConfig id={section?.sectionId} key={section.sectionId}>
        <Box
          bgImg={section.styleConfig.bgImage.url}
          bgRepeat="no-repeat"
          bgSize="cover"
          mt={{ base: '-140px', md: '-60px', lg: '-105px' }}
          pt={{ base: '50px', md: '120px' }}
          position="relative"
          pb="80px"
        >
          {section?.sectionContent?.map((content, index) => {
            if (content._modelApiKey === 'section_title') {
              return <KsSectionTitle sectionContent={content} isFaq={true} />;
            } else if (content._modelApiKey === 'faq_section') {
              return <KshetraFaq key={content.id} sectionContent={content} />;
            } else {
              return null;
            }
          })}
        </Box>
      </StyleConfig>
    );
  } else if (section.sectionId === 'kshetra-sankalpa') {
    return <EmbedVideo sectionContent={section.sectionContent} />;
  } else if (section.sectionId === 'ks-sticky-button') {
    return <KsStickyButton sectionContent={section.sectionContent} />;
  } else if (section.sectionId === 'highlights') {
    return (
      <Box
        bgImg={section.styleConfig?.bgImage?.url}
        bgRepeat="no-repeat"
        bgSize={'cover'}
        bgPos={{ md: '0 -40px', xl: '0 -120px' }}
        pt={{ base: '50px', md: '40px' }}
        pb={{ base: '160px', md: '100px', xl: '200px' }}
        width="100%"
        position="relative"
        zIndex={9}
      >
        {section.sectionContent.map((content, index) => {
          if (content._modelApiKey === 'section_title') {
            return <KsSectionTitle sectionContent={content} />;
          } else if (content._modelApiKey === 'sankalpa_zigzag_card') {
            return <KshetraYatra key={index} sectionData={content} />;
          } else {
            return null;
          }
        })}
      </Box>
    );
  } else if (section.sectionId === 'additional-program-features') {
    return (
      <Box
        id="ks-program-details"
        backgroundImage={{
          base: 'url("https://www.datocms-assets.com/46272/1736440600-ksinfo3mobilebg.png")',
          md: section.styleConfig.bgImage?.url,
        }}
        bgRepeat="no-repeat"
        bgSize={{ base: '200%', md: 'cover' }}
        bgPosition="center"
        pt={{ base: '70px', md: '130px', lg: '150px' }}
        pb={{ base: '30px', md: '40px' }}
        mt={{ base: '-130px', md: '-135px', xl: '-220px' }}
        width="100%"
        position="relative"
        zIndex={1}
      >
        {section.sectionContent.map((content, index) => {
          if (content._modelApiKey === 'section_title') {
            return <KsSectionTitle sectionContent={content} />;
          } else if (content._modelApiKey === 'card_info3_column_group') {
            return <SankalpaCardInfo3 key={index} sectionContent={content} />;
          } else {
            return null;
          }
        })}
      </Box>
    );
  } else if (section.sectionId === 'idy-testimonials') {
    return (
      <IdyTestimonial
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'benefits-of-mind') {
    return (
      <MeditationSlider
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'what-is-mom') {
    return (
      <WhatisMom
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'mom-register-sticky-button') {
    return (
      <MomStickyButton
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'mom-form') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <MomForm
          section={section.sectionContent}
          region={region}
          language={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'mom-quote') {
    return (
      <MomQuote
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'mom-footer') {
    return (
      <MomFooter
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'miracle-top-banner') {
    return (
      <MiracleTopBanner
        section={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'idy-in-person') {
    return (
      <IdyInPerson
        sectionContent={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (section.sectionId === 'idy-faq-section') {
    return (
      <FaqContents
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
      />
    );
  } else if (section.sectionId === 'idy-register-sticky-button') {
    return (
      <IdyRegisterStickyButton
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
      />
    );
  } else if (section.sectionId === 'about-sadhguru') {
    // const AboutSadhguru = dynamic(() => import('@sections/AboutSadhguru'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <AboutSadhguru section={section} region={region} lang={lang} />
      </StyleConfig>
    );
  } else if (
    section.sectionId === 'right-zigzag-0' ||
    section.sectionId === 'right-zigzag-1'
  ) {
    // const RightZigzag = dynamic(() => import('@sections/events/RightZigzag'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <RightZigzag section={section} region={region} lang={lang} />
      </StyleConfig>
    );
  } else if (
    section.sectionId === 'left-zigzag-1' ||
    section.sectionId === 'left-zigzag-0'
  ) {
    // const LeftZigzag = dynamic(() => import('@sections/events/LeftZigzag'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <LeftZigzag section={section} region={region} lang={lang} />
      </StyleConfig>
    );
  } else if (section.sectionId === 'fashion-zigzag-cards-index') {
    return false;
  } else if (section.sectionId === 'naga-testimonials') {
    return <Testimonials3Card section={section} />;
  } else if (section.sectionId === 'ps-social-section') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <SocialSection
          key={nanoid(5)}
          section={section}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  }
  // else if (section.sectionId === 'pricing') {
  //   return <TamilPricing section={section} region={region} lang={lang} />;
  // } else if (section.sectionId === 'course-structure') {
  //   return <TamilCard section={section} region={region} lang={lang} />;
  // }
  else if (section.sectionId === 'lom-benefits') {
    return <EoeStyleConfig
      id={section.sectionId}
      key={section.sectionId}
      pT="0"
      pB="0"
      mB="0"
      section={section}
    >
      <EOEBenefitsGroup
        sectionContent={section.sectionContent}
        section={section}
        region={region}
        lang={lang}
      />
    </EoeStyleConfig>
  }
  else if (section.sectionId === 'sticky-button-lom') {
    const RegisterStickyButton = dynamic(() =>
      import('@components/Buttons/LomRegisterStickyButton')
    );
    return (
      <RegisterStickyButton
        lang={lang}
        region={region}
        sectionContent={section.sectionContent}
      />
    );
  }
  else if (section?.sectionId === 'program-details-lom') {
    const LapOfMasterProgramDetail = dynamic(() =>
      import('@components/UI/ProgramCategory/ProgramDetailsLOM')
    );
    return <LapOfMasterProgramDetail
      section={section?.sectionContent}
      region={region}
      lang={lang}
      sectionId={section?.sectionId}
    />
  }
  else if (section?.sectionId === 'program-details-lom-youth') {
    const LapOfMasterYouthProgramDetail = dynamic(() =>
      import('@components/UI/ProgramCategory/ProgramDetailsLOMYouth')
    );
    return <LapOfMasterYouthProgramDetail
      section={section?.sectionContent}
      region={region}
      lang={lang}
      sectionId={section?.sectionId}
    />
  }
  else if (section?.sectionId === 'program-details-lom-youth-tamil') {
    const LapOfMasterYouthProgramDetailTamil = dynamic(() =>
      import('@components/UI/ProgramCategory/ProgramDetailsLOMYouthTamil')
    );
    return <LapOfMasterYouthProgramDetailTamil
      section={section?.sectionContent}
      region={region}
      lang={lang}
      sectionId={section?.sectionId}
    />
  }
  else if (
    section._modelApiKey === 'page_section_left_nav' &&
    (section.sectionId === 'course-highlights' ||
      section.sectionId === 'benefits')
  ) {
    // const ThreeColumnGroup = dynamic(() => import('@landing_pages/inner-engineering-online/ThreeColumnGroup'));
    return <ThreeColumnGroup section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'research-findings') {
    // const TamilResearch = dynamic(() => import('@landing_pages/inner-engineering-online/TamilResearch'));
    return <TamilResearch section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'benefits') {
    // const ArtworkText3GroupColumn = dynamic(() => import('@sections/ArtworkText3GroupColumn'));
    return (
      <ArtworkText3GroupColumn
        sectionContent={section}
        region={region}
        lang={lang}
      />
    );
  }
  else if (section.sectionId === 'otp-benefits' || section.sectionId === 'surya-shakti-benefits') {
    return <Benefits3GroupColumn 
      sectionContent={section.sectionContent}
      region={region}
      lang={lang}
      sectionId={section.sectionId}
      />
  }
  else if (section.sectionId === 'otp-our-team') {
    return <OurTeamBanner 
      sectionContent={section.sectionContent}
      region={region}
      lang={lang} />
  }
  else if (section.sectionId === 'testimonial-otp') {
    return (
        <Box
          display="flex">
          <OtpTestimonials
            sectionContent={section?.sectionContent}
          />
        </Box>
    );
  }
  else if (section.sectionId === 'testimonial-otp') {
    return (
        <Box
          display="flex">
          <OtpTestimonials
            sectionContent={section?.sectionContent}
          />
        </Box>
    );
  }
  else if (section.sectionId === 'journey-ad-banner') {
    return (
      <JourneyAdBanner sectionContent={section?.sectionContent} />
    );
  }
  else if (section.sectionId === 'journey-section') {
    return (
      <OtpJourneyOverview sectionContent={section?.sectionContent} />
    );
  }
  else if (section.sectionId === IsoApiConstants.sectionId.architecture) {
    const Architecture = dynamic(() =>
      import('@sections/centers/Architecture')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <Architecture
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === IsoApiConstants.sectionId.globalCenters) {
    // const GlobalCenter = dynamic(() => import('@components/UI/Center/GlobalCenter'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <GlobalCenter
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'main-centers-default-image') {
    // const MainCentersDefaultImage = dynamic(() => import('@sections/centers/MainCentersDefaultImage'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <MainCentersDefaultImage sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (
    section.sectionId === 'view-all-centers' ||
    section.sectionId === 'view-all-center-section' ||
    section.sectionId === 'view-all-centers-section'
  ) {
    // const AllCenters = dynamic(() => import('@sections/centers/AllCenters'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <AllCenters section={section} />
      </StyleConfig>
    );
  } else if (
    section.sectionId === 'teachers-in-your-area' ||
    section.sectionId === 'Find a Teacher'
  ) {
    // const FindTeacher = dynamic(() => import('@sections/yoga-meditation/FindTeacher'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <FindTeacher
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
          isLeftMenu={isLeftMenu}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'online-satsang-banner') {
    // /events/monthly/online-satsang
    // const OnlineSatsangBanner = dynamic(() => import('@landing_pages/online-satsang/OnlineSatsangBanner'));
    return (
      // <StyleConfig key={section.sectionId} style={section?.styleConfig}>
      <OnlineSatsangBanner
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
      // </StyleConfig>
    );
  } else if (section.sectionId === 'wide-sadhguru-box') {
    // ishanga 7 landing
    // const WideSadhguruBox = dynamic(() => import('@landing_pages/ishanga7/WideSadhguruBox'));
    return (
      // <StyleConfig key={section.sectionId} style={section?.styleConfig}>
      <WideSadhguruBox
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />

      // </StyleConfig>
    );
  } else if (section.sectionId === 'exploring-spiritual-america-poem') {
    // events/special-events/exploring-spiritual-america
    // const ExploringSpiritualAmericaPoem = dynamic(() => import('@sections/events/ExploringSpiritualAmericaPoem'));
    return (
      // <StyleConfig key={section.sectionId} style={section?.styleConfig}>
      <ExploringSpiritualAmericaPoem
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
      // </StyleConfig>
    );
  } else if (section.sectionId === '2-column-hatha-teachers-block') {
    // events/special-events/exploring-spiritual-america
    // const TwoColumnHathaTeachersBlock = dynamic(() => import('@sections/yoga-meditation/TwoColumnHathaTeachersBlock'));
    return (
      // <StyleConfig key={section.sectionId} style={section?.styleConfig}>
      <TwoColumnHathaTeachersBlock
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
      // </StyleConfig>
    );
  } else if (section.sectionId === '2-column-living-isha-block') {
    // center/isha-institute-inner-sciences/living-isha
    const LivingIsha = dynamic(() => import('@sections/centers/LivingIsha'));
    return <LivingIsha section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'upcoming-programs-hatha-backend') {
    // yoga-meditation/yoga-program-for-beginners/hatha-yoga/courses-by-certified-teachers
    const UpcomingProgramsV2 = dynamic(() =>
      import('@components/UI/UpcomingProgramsV2')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <UpcomingProgramsV2
          sectionContent={section?.sectionContent[0]}
          region={region}
          language={lang}
          isLeftMenu={isLeftMenu}
          apiType="macro"
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'marketo-form-upa-yoga-ishanga') {
    // yoga-meditation/yoga-program-for-beginners/hatha-yoga/courses-by-certified-teachers
    const MarketoFormSection = dynamic(() =>
      import('@sections/yoga-meditation/MarketoForm')
    );
    return (
      <MarketoFormSection
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
        pType={pType}
        pageName={pageName}
      />
    );
  } else if (section.sectionId === 'donation-page-offline-donation-ui') {
    // const DonationPageOfflineDonationUi = dynamic(() => import('@sections/donation/DonationPageOfflineDonationUi'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <DonationPageOfflineDonationUi
          section={section}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'placeholder-donate-offline-form') {
    const PlaceholderDonateOfflineForm = dynamic(() =>
      import('@sections/donation/PlaceholderDonateOfflineForm')
    );
    return (
      <PlaceholderDonateOfflineForm
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
        pType={pType}
        pageName={pageName}
      />
    );
  } else if (section.sectionId === 'social-media-icons-latest') {
    // const SocialMediaIconsLatest = dynamic(() => import('@sections/SocialMediaIconsLatest'));
    return (
      <SocialMediaIconsLatest
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
        pType={pType}
        pageName={pageName}
      />
    );
  } else if (section.sectionId === 'us_donation_employer_match') {
    const UsDonationEmployerMatch = dynamic(() =>
      import('@sections/donation/UsDonationEmployerMatch')
    );
    return (
      <UsDonationEmployerMatch
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
        pType={pType}
        pageName={pageName}
        shouldLoad
      />
    );
  } else if (section.sectionId === 'donation-page-top-banner') {
    // const DonationPageTopBanner = dynamic(() => import('@sections/donation/DonationPageTopBanner'));
    return (
      <DonationPageTopBanner
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
        pType={pType}
        pageName={pageName}
      />
    );
  } else if (section.sectionId === 'seating-reg-section') {
    // const SeatingRegSection = dynamic(() => import('@sections/SeatingRegSection'));
    return (
      <SeatingRegSection
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
        pType={pType}
        pageName={pageName}
      />
    );
  } else if (section.sectionId === 'why-take-a-break') {
    // const SPTakeBreak = dynamic(() => import('@landing_pages/Sadhanapada/SPTakeBreak'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
      >
        <SPTakeBreak
          section={section}
          region={region}
          lang={lang}
          isLeftMenu={isLeftMenu}
          pType={pType}
          pageName={pageName}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'sp-program-details') {
    // const SPProgramDetails = dynamic(() => import('@landing_pages/Sadhanapada/SPProgramDetails'));
    return (
      <SPProgramDetails
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  } else if (section.sectionId === 'path-to-sadhanapada') {
    // const SPPath = dynamic(() => import('@landing_pages/Sadhanapada/SPPath'));
    return (
      <SPPath
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  }
  // else if (section.sectionId === 'participant_stories') {
  //   return (
  //     <SPAlumni
  //       section={section}
  //       region={region}
  //       lang={lang}
  //       isLeftMenu={isLeftMenu}
  //     />
  //   );
  // }
  else if (section.sectionId === 'sp-faq') {
    // const SPFaq = dynamic(() => import('@landing_pages/Sadhanapada/SPFaq'));
    return (
      <SPFaq
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  } else if (section.sectionId === 'participant_stories') {
    // const SPAlumni = dynamic(() => import('@landing_pages/Sadhanapada/SPAlumni'));
    return (
      <SPAlumni
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  } else if (section.sectionId === 'why-sadhanapada') {
    // const WhySP = dynamic(() => import('@landing_pages/Sadhanapada/WhySP'));
    return (
      <WhySP
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  } else if (section.sectionId === 'join-webinar') {
    // const SPWebinar = dynamic(() => import('@landing_pages/Sadhanapada/SPWebinar'));
    return (
      <SPWebinar
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  } else if (section.sectionId === 'apply-now') {
    // const SPApply = dynamic(() => import('@landing_pages/Sadhanapada/SPApply'));
    return (
      <SPApply
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  } else if (section.sectionId === 'stay-in-touch-mobile-app-section') {
    // const MobileApp = dynamic(() => import('@sections/others/MobileApp'));
    return (
      <MobileApp
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
    // http://localhost:3001/in/ta/maranambook
  } else if (section.sectionId === 'buy-now-section') {
    // const BuyNow = dynamic(() => import('@sections/others/BuyNow'));
    return (
      <BuyNow
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
    // http://localhost:3001/in/en/stay-in-touch-with-sadhguru-and-isha
  } else if (section.sectionId === 'isha-outreach') {
    // http://localhost:3001/in/en/about-isha-foundation
    // const IshaOutreach = dynamic(() => import('@sections/isha-outreach/IshaOutreach'));
    return <IshaOutreach section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'educational-initiatives') {
    // const EducationalInitiatives = dynamic(() => import('@sections/educational-initiatives/EducationalInitiatives'));
    return (
      <EducationalInitiatives section={section} region={region} lang={lang} />
    );
  } else if (section.sectionId === 'sadhguru-app-button') {
    // const AppButton = dynamic(() => import('@sections/others/AppButton'));
    return (
      <AppButton
        section={section}
        region={region}
        lang={lang}
        isLeftMenu={isLeftMenu}
      />
    );
  } else if (section.sectionId === 'donation-thankyou') {
    const DonationThankYou = dynamic(() =>
      import('@sections/donation/DonationThankYou')
    );
    return <DonationThankYou section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'accordion-faq') {
    // const AccordionFaq = dynamic(() => import('@components/Accordions/AccordionFaq'));
    return <AccordionFaq section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'celebrate-the-weaves') {
    const CelebrateWeaves = dynamic(() =>
      import('@sections/outreach/CelebrateWeaves')
    );
    return <CelebrateWeaves region={region} lang={lang} section={section} />;
  } else if (section.sectionId === 'author-vd-section') {
    // /in/en/author
    const AuthorVdSection = dynamic(() =>
      import('@sections/others/AuthorVdSection')
    );
    return <AuthorVdSection region={region} lang={lang} section={section} />;
  } else if (section.sectionId === 'ishanga-stickybar') {
    // ishanga 7
    // let condition = true;
    // const IshangaStickyBar = condition && import('@sections/ishanga/IshangaStickyBar')
    const IshangaStickyBar = dynamic(() =>
      import('@sections/ishanga/IshangaStickyBar')
    );
    return (
      <IshangaStickyBar
        region={region}
        lang={lang}
        section={section}
        pageBody={pageBody}
      />
    );
  } else if (section.sectionId === 'ishanga-poem-section') {
    // ishanga 7
    const IshangaPoemSection = dynamic(() =>
      import('@sections/ishanga/IshangaPoemSection')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        pT="0"
        mT="90px"
        mB="30px"
      >
        <IshangaPoemSection region={region} lang={lang} section={section} />
      </StyleConfig>
    );
  } else if (section.sectionId === 'bog-register') {
    // BOG
    const BogRegister = dynamic(() => import('@sections/ishanga/BogRegister'));
    return <BogRegister region={region} lang={lang} section={section} />;
  } else if (section.sectionId === 'bog-header') {
    // BOG
    const BogHeader = dynamic(() => import('@sections/ishanga/BogHeader'));
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        pb="20px"
        pt="30px"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
      >
        <BogHeader region={region} lang={lang} section={section} />
      </StyleConfig>
    );
  } else if (section.sectionId === 'fyd-register-sticky-button') {
    const FYDRegisterStickyButton = dynamic(() =>
      import('@components/Buttons/FYDRegisterStickyButton')
    );
    return (
      <FYDRegisterStickyButton
        disableButton={disableButton}
        FYDdate={FYDdate}
        lang={lang}
        region={region}
        sectionContent={section.sectionContent}
        pageName={pageName}
        csrData={csrData}
      />
    );
  } 
  else if (section.sectionId === 'otp-quote-section'){
    return <OTPQuoteSection sectionContent={section.sectionContent} />
  }
  else if (
    section.sectionId === 'quote-section' ||
    section.sectionId === 'idy-quote'
  ) {
    // Volunteer
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        pb="10px"
        pt="10px"
        mb={{ base: '25px', md: '40px' }}
        mt="-5px"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
      >
        <QuoteSection region={region} lang={lang} section={section} />
      </StyleConfig>
    );
  } else if (
    section.sectionId === 'various-volunteer-section' ||
    section.sectionId === 'other-volunteer-section' ||
    section.sectionId === 'ssb-volunteer-section'
  ) {
    // Volunteer
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        pb="0px"
        pt="0px"
        backgroundRepeat="no-repeat"
        backgroundSize={{ base: '500px', sm: 'cover', md: 'cover' }}
      >
        <VariousVolunteerSection
          region={region}
          lang={lang}
          section={section}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'event-program-details-section') {
    const ProgramCategory = dynamic(() =>
      import('@components/Layout/ProgramCategory')
    );
    return <ProgramCategory region={region} lang={lang} section={section} />;
  } else if (section.sectionId === 'event-programcard-section') {
    const EventProgramCard = dynamic(() =>
      import('@components/Layout/EventProgramCard')
    );
    return <EventProgramCard region={region} lang={lang} section={section} />;
  } else if (section.sectionId === 'mmm-eventbanner') {
    const TopBannerEventMmm = dynamic(() =>
      import('@components/HeaderBanner/TopBannerEventMMM')
    );
    return (
      <Box minH="500px" bgColor={section?.styleConfig?.bgColour?.hex || null}>
        <StyleConfig
          id={section?.sectionId}
          key={section.sectionId}
          style={section?.styleConfig}
          mb="0"
          pT="0"
          pB="0"
        >
          <TopBannerEventMmm
            section={section}
            region={region}
            language={lang}
          />
        </StyleConfig>
      </Box>
    );
  } else if (section.sectionId === 'event-program-tab-section') {
    const ProgramTabSection = dynamic(() =>
      import('@components/Layout/ProgramTabSection')
    );
    return (
      <ProgramTabSection section={section} region={region} language={lang} />
    );
  } else if (section.sectionId === 'how-to-get-there-ys') {
    const HowtoGetThere = dynamic(() =>
      import('@components/UI/LandingPages/Howtogetthere')
    );
    return <HowtoGetThere section={section} region={region} language={lang} />;
  } else if (section.sectionId === 'how-to-reach') {
    const HowtoReach = dynamic(() =>
      import('@components/UI/Events/mmm/HowtoReach')
    );
    return <HowtoReach section={section} region={region} language={lang} />;
  } else if (section.sectionId === 'mmmgeneral-seating') {
    const GeneralSeating = dynamic(() =>
      import('@components/UI/Events/mmm/GeneralSeating')
    );
    return (
      <GeneralSeating
        region={region}
        lang={lang}
        section={section}
        csrData={csrData}
      />
    );
  } else if (section.sectionId === 'event-programcategory') {
    const ProgramCategory = dynamic(() =>
      import('@components/UI/Events/EventProgramCategory')
    );
    return (
      <ProgramCategory
        region={region}
        lang={lang}
        section={section}
        csrData={csrData}
      />
    );
  } else if (section.sectionId === 'early-bird-block') {
    const EarlyBird = dynamic(() =>
      import('@components/UI/Events/mmm/EarlyBird')
    );
    return <EarlyBird section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'sadhana-detail-list') {
    const SadhanaDetailList = dynamic(() =>
      import('@components/Card/SadhanaDetailList')
    );
    return <SadhanaDetailList region={region} lang={lang} section={section} />;
  } else if (section.sectionId === 'ishanga7-desc-popup') {
    const PopupWindow = dynamic(() =>
      import('@components/UI/Events/PopupWindow')
    );
    return <PopupWindow region={region} lang={lang} section={section} />;
  } else if (section.sectionId === 'faq-plusminus') {
    const FaqPlusMinus = dynamic(() =>
      import('@components/Accordions/FaqPlusMinus')
    );
    return <FaqPlusMinus section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'contact-us-mmm') {
    const ContactMMM = dynamic(() => import('@landing_pages/MMM/Contactus'));
    return <ContactMMM section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'top-banner-ys') {
    // Yoga Sandhya page
    return (
      <TopBannerYs
        section={section}
        region={region}
        lang={lang}
        csrData={csrData}
        currentRegion={currentRegion}
      />
    );
  } else if (section.sectionId === 'top-banner-social-media') {
    // sadhguru-isha-digital-handles
    return (
      <TopBannerSM
        sectionContent={section.sectionContent[0]}
        region={region}
        lang={lang}
        csrData={csrData}
        currentRegion={currentRegion}
      />
    );
  } else if (section.sectionId === 'social-media-links') {
    // sadhguru-isha-digital-handles
    return (
      <OfficialDigitalHandles
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
      />
    );
  } else if (section.sectionId === 'benefits-ys') {
    // Yoga Sandhya page
    return <BenefitsGroup section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'program-details') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
      >
        <ProgDetailYs section={section} region={region} lang={lang} />
      </StyleConfig>
    );
  } else if (section.sectionId === 'pbk-program-details') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
      >
        <ProgDetailPBK
          section={section}
          region={region}
          lang={lang}
          csrData={csrData}
          currentRegion={currentRegion}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'support-email') {
    return (
      <SupportEmail
        section={section}
        region={region}
        lang={lang}
        csrData={csrData}
      />
    );
  } else if (section.sectionId === 'content-for-us1') {
    return <HighlightsPBK section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'content-for-us2') {
    return <FeaturesPBK section={section} region={region} lang={lang} />;
  } else if (section.sectionId === 'challenge-form') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
      >
        <ChallengeForm
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'invite-friends') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
      >
        <InviteFriends
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'idy-benefits') {
    return (
      <IdyBenefits
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
      />
    );
  } else if (section.sectionId === 'idy-imp-msg') {
    return (
      <IdyImportantMessage
        sectionContent={section.sectionContent[0]}
        region={region}
        lang={lang}
      />
    );
  } else if (section.sectionId === 'adiyogi-community-declaration') {
    return (
      <CommunityDeclaration
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
      />
    );
  } else if (section.sectionId === 'sahabhagi-steps-involved') {
    const SahabhagiSteps = dynamic(() =>
      import('@components/Card/SahabhagiStepsInvolved')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
      >
        <SahabhagiSteps
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'uym-header-section') {
    const UymTopBanner = dynamic(() =>
      import('@components/HeaderBanner/TopBannerUym')
    );
    return (
      <UymTopBanner
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        pageConfig={pageConfig}
      />
    );
  } else if (section.sectionId === 'surya-shakti-header-section') {
    const SuryaShaktiTopBanner = dynamic(() =>
      import('@components/HeaderBanner/SuryaShaktiTopBanner')
    );
    return (
      <SuryaShaktiTopBanner
        allSections={section.sectionContent}
        sectionContent={section.sectionContent[0]}
        region={region}
        lang={lang}
        pageConfig={pageConfig}
        sectionId={section?.sectionId}
      />
    );
  } else if (section.sectionId === 'uym-program-includes') {
    const UymProgramIncludes = dynamic(() =>
      import('@components/Card/UymCardZigzagGroup')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
        mb="40px"
      >
        <UymProgramIncludes
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'uym-program-information') {
    const UymProgramInfo = dynamic(() =>
      import('@components/uyirnokkam/UymProgramInfo')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
        mb="40px"
      >
        <UymProgramInfo
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'uym-benefits') {
    const UymBenefits = dynamic(() =>
      import('@components/uyirnokkam/UymBenefits')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        // style={section?.styleConfig}
        section={section}
        pt="0"
      >
        <UymBenefits
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
          bgstyle={section?.styleConfig}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'uym-sharing') {
    const UymSharing = dynamic(() =>
      import('@components/uyirnokkam/UymSharing')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
        mb="40px"
      >
        <UymSharing
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'surya-shakti-sharing') {
    const SuryaShaktiSharing = dynamic(() =>
      import('@components/SuryaShakti/SuryaShaktiSharing')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
        mb="40px"
      >
        <SuryaShaktiSharing
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'uym-program-importance') {
    const UymImportance = dynamic(() =>
      import('@components/uyirnokkam/UymImportance')
    );
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
        pt="0"
        mb="40px"
      >
        <UymImportance
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'uym-sticky-button') {
    const UymRegisterStickyButton = dynamic(() =>
      import('@components/uyirnokkam/UymRegisterStickyButton')
    );
    return (
      <UymRegisterStickyButton
        sectionContent={section.sectionContent}
        lang={lang}
        region={region}
      />
    );
  } else if (section.sectionId === 'uym-faq-section') {
    const UymFaq = dynamic(() => import('@components/uyirnokkam/UymFaq'));
    return (
      <UymFaq
        sectionContent={section.sectionContent}
        lang={lang}
        region={region}
        pageConfig={pageConfig}
      />
    );
  } else if (section.sectionId === 'uym-contact-us') {
    const UymContactUs = dynamic(() =>
      import('@components/uyirnokkam/UymContactUs')
    );
    return (
      <UymContactUs
        sectionContent={section.sectionContent}
        lang={lang}
        region={region}
      />
    );
  } else if (section.sectionId === 'csrslider-banner') {
    const CSRTopSliderGroup = dynamic(() =>
      import('@landing_pages/donation/components/CSRTopSliderGroup')
    );
    return (
      <CSRTopSliderGroup
        sectionContent={section.sectionContent[0]}
        lang={lang}
        region={region}
        // background={`linear-gradient(360deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0) 158.2%)`}
      />
    );
  }  else if (section.sectionId === 'donate-featured-card') {
    const DonateFeatureCard = dynamic(() =>
      import('@landing_pages/donation/components/DonateFeatureCard')
    );
    return (
      <DonateFeatureCard
        sectionContent={section.sectionContent}
        lang={lang}
        region={region}
      />
    );
  } else if (section.sectionId === 'donation-group-card') {
    const DonationGroupCard = dynamic(() =>
      import('@landing_pages/donation/components/DonationGroupCard')
    );
    return (
      <DonationGroupCard
        sectionContent={section.sectionContent}
        lang={lang}
        region={region}
      />
    );
  } else if (section.sectionId === 'chyp-sadhana-details') {
    const ChypSadhana = dynamic(() =>
      import('@landing_pages/chyp/ChypSadhanaDetail')
    );
    return (
      <StyleConfig id={section?.sectionId}>
        <ChypSadhana
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if (section.sectionId === 'chyp-contact-us') {
    const ChypContact = dynamic(() =>
      import('@landing_pages/chyp/ChypContactus')
    );
    return (
      <StyleConfig id={section?.sectionId}>
        <ChypContact
          sectionContent={section.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  } else if(section.sectionId === 'death-book-ad-banner'){
    const DeathBookBanner = dynamic(() =>
      import('@landing_pages/death-book/DeathBookBanner')
    );
    return <DeathBookBanner section={section}/>   
  } else {
    return (
      <Box as="div" display="block" placeContent="center">
        <StyleConfig
          id={section?.sectionId}
          key={section.sectionId}
          style={section?.styleConfig}
          section={section}
        >
          {section?.sectionContent?.length > 0
            ? section?.sectionContent?.map((secCon, i) => {
                return (
                  <SectionUI
                    key={i}
                    sectionContent={secCon}
                    section={section}
                    region={region}
                    language={lang}
                    isLeftMenu={isLeftMenu}
                    pType={pType}
                    pageName={pageName}
                    csrData={csrData}
                    pageBody={pageBody}
                    FYDdate={FYDdate}
                    pageConfig={pageConfig}
                    disableButton={disableButton}
                  />
                );
              })
            : null}
        </StyleConfig>
      </Box>
    );
  }
};

export { RenderFAQs, RenderSections, RenderSimpleButton, RenderStructuredText };
